var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacetime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333e49;opacity:0.7;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FACETIME"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 500,
    cy: 500,
    r: 455.61
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M544,361.74H322.69a36.46,36.46,0,0,0-36.36,36.36V601.9a36.46,36.46,0,0,0,36.36,36.36H544A36.46,36.46,0,0,0,580.3,601.9V398.1A36.46,36.46,0,0,0,544,361.74Zm-114,214.83c-9.42,0-16.79-7.24-16.79-16.05a16.57,16.57,0,0,1,16.79-16.27c9.21,0,16.78,7.48,16.78,16.27S439.15,576.57,429.94,576.57Zm32.42-78.07-9.88,6.61C444.91,510.16,441,517.41,441,526a18.18,18.18,0,0,0,.21,2.88h-23c-.21-2.88-.45-5.27-.45-8.36,0-13.21,5.3-24,18.63-33.21L447,480c7.57-5.27,10.78-11.67,10.78-19.15,0-11.42-8-22.21-24.81-22.21-17,0-26,12.55-26,25.09v.1a9,9,0,0,1-9.5,9.06l-8.12-.56a8.83,8.83,0,0,1-8.27-8.17c-.05-.81-.07-1.62-.07-2.43,0-22,17.24-46,52-46,34,0,52.41,21.57,52.41,44C485.35,477.17,475.69,489.47,462.36,498.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M608.27,548.18V451.8A24.27,24.27,0,0,1,617,433.21l60.36-50.48a24.24,24.24,0,0,1,36.36,21V596.28a24.24,24.24,0,0,1-36.36,21L617,566.77A24.25,24.25,0,0,1,608.27,548.18Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacetime);
export default __webpack_public_path__ + "static/media/facetime.af6df2350875019daced8cbf736555f7.svg";
export { ForwardRef as ReactComponent };